import{a as n}from"./chunk-DEVKGLTN.js";import{a as t}from"./chunk-RAAYCPUM.js";function a(...e){return t(o,e)}var o=e=>n(e).join("-").toLowerCase();export{a};
